module.exports = __webpack_public_path__ + "img/证书3.3c48943b.png";